import { createFileRoute } from '@tanstack/react-router'
import BundleContainer from 'Bundle/containers/BundleContainer'

export const Route = createFileRoute('/bundle/_main/create')({
    component: BundleContainer,
})
